module.exports = new __parcel__URL__("battleroyale_space_elixir_icon.3d848cf8.png").toString();